var selectedColor;
var selectedGrade;
var selectedFabric;
var selectedSeries;
var selectedFeature; // ✅ NEW
var EleHeight;
var itemCount;

class americanSwatch {
  constructor(){

    const radioButtonsColor = document.querySelectorAll('[data_color]');
    const radioButtonsGrade = document.querySelectorAll('[data_grade]');
    const radioButtonsFabric = document.querySelectorAll('[data_fabric]');
    const radioButtonsSeries = document.querySelectorAll('[data_series]');
    const radioButtonsFeature = document.querySelectorAll('[data_feature]'); // ✅ NEW
    const gridItems = document.querySelectorAll('[data-swatch-item]');

    itemCount = gridItems.length;

    if(gridItems.length > 1){
      EleHeight = gridItems[1].querySelector(".swatch-more-wrapper").offsetHeight;
      gridItems[0].querySelector("[swatch_detials]").style.height = `${EleHeight}px`;
    }

    // Events
    radioButtonsColor.forEach(ele=>{
      ele.addEventListener("change",(e)=>{
        if(e.target.checked){
          selectedColor = e.target.value;
          this._loadSwatchGrid();
        }
      });
    });

    radioButtonsFabric.forEach(ele=>{
      ele.addEventListener("change",(e)=>{
        if(e.target.checked){
          selectedFabric = e.target.value;
          this._loadSwatchGrid();
        }
      });
    });

    radioButtonsGrade.forEach(ele=>{
      ele.addEventListener("change",(e)=>{
        if(e.target.checked){
          selectedGrade = e.target.value;
          this._loadSwatchGrid();
        }
      });
    });

    radioButtonsSeries.forEach(ele=>{
      ele.addEventListener("change",(e)=>{
        if(e.target.checked){
          selectedSeries = e.target.value;
          this._loadSwatchGrid();
        }
      });
    });

    // ✅ FEATURE
    radioButtonsFeature.forEach(ele=>{
      ele.addEventListener("change",(e)=>{
        if(e.target.checked){
          selectedFeature = e.target.value;
          this._loadSwatchGrid();
        }
      });
    });

    gridItems.forEach(ele=>{
      ele.addEventListener("click",(event)=>{
        this._showItemDetials(event);
      });
    });

  }

  _checkFeature(item){
    if(!selectedFeature) return true;
   
    return item.feature && item.feature.includes(selectedFeature);
  }

  _loadSwatchGrid(){
    const gridElements = document.querySelectorAll('[data-swatch-details]');
    let count = 0;

    gridElements.forEach(ele=>{
      var data = JSON.parse(ele.textContent);
      let itemFound = false;

      data.forEach(item => {
        const match =
          (!selectedColor || item.color?.includes(selectedColor)) &&
          (!selectedFabric || item.fabric_type?.includes(selectedFabric)) &&
          (!selectedGrade || item.grade == selectedGrade) &&
          (!selectedSeries || item.series?.includes(selectedSeries)) &&
          (!selectedFeature || item.feature?.includes(selectedFeature));

          console.log('match',match)
        if(match){
          itemFound = true;
        }
      });

      if(!itemFound){
        ele.closest("[data-swatch-item]").classList.add("d-none");
        count++;
      }else{
        ele.closest("[data-swatch-item]").classList.remove("d-none");
      }

    });

    if(count === itemCount){
      document.querySelector("[empty-search]").classList.remove("d-none");
    }else{
      document.querySelector("[empty-search]").classList.add("d-none");
    }
  }

  _showItemDetials(event){
    let currentEle = event.currentTarget;

    document.querySelectorAll('[data-swatch-item]').forEach(ele=>{
      ele.classList.remove("active");
      ele.querySelector(".image_wrapper").classList.remove("active");
      ele.querySelector("[swatch_detials]").removeAttribute('style');
    });

    currentEle.classList.add("active");
    currentEle.querySelector(".image_wrapper").classList.add("active");

    var height_el = currentEle.querySelector('.swatch-more-wrapper').offsetHeight;
    currentEle.querySelector("[swatch_detials]").style.height = `${height_el}px`;
  }
}

new americanSwatch();